<template>
    <div>
        <div id="main-container" :style="{backgroundImage: 'url(' + bgImg + ')'}" v-if="couldRender">
            <div id="turnplate" data-spider="PRLYujHT92">
                <div class="outer-1"></div>
                <div class="my-award" data-spider="dMyAward" data-spider-action-name="dMyAward"
                     data-spider-action-args='{}' spm-auto="我的奖品" spm-click="click" @click="goAwardsPage"></div>
                <div :class="['real-deg',outerPanelClass]">
                    <div :class="['inner-1',panelRotateClass]" :style="panelStyle"></div>
                </div>
                <div :class="['inner-2',pointerClass]" data-spider="dPlay" data-spider-action-name="dPlay"
                     data-spider-action-args='{}' spm-auto="抽奖" spm-click="click" @click="play">
                    <i class="pointer-triangle"></i>
                    <div class="pointer-circle"></div>
                    <div class="lottery-word-1">抽奖</div>
                </div>
                <div v-if="activityStatus === 0" class="chance-left">还有{{chanceLeft}}次机会</div>
                <div v-else-if="activityStatus >= 1 && activityStatus <= 3" class="chance-left">{{activityStatusStr}}
                </div>
                <ul class="links"
                    v-if="typeof panelInfo.data.features.links !== 'undefined' && panelInfo.data.features.links.length > 0">
                    <li v-for="item in panelInfo.data.features.links"><a :href="item.url" data-spider
                                                                         :spm-auto="item.text">{{item.text}}</a></li>
                </ul>
                <!-- <div id="btn1" class="btn"><a :href="panelInfo.data.features.descriptionUrl">活动介绍</a></div> -->
                <!-- <div @click="goAwardsPage" class="link">
                    <div id="btn2" class="btn">我的奖品<span v-if="awardCnt > 0">[{{awardCnt}}]</span></div>
                </div> -->
            </div>
        </div>
        <vm-confirm :show="confirmFlag" :img="confirmImg" @close="closeConfirm"></vm-confirm>
        <vm-error :config="errorConfig"></vm-error>
    </div>
</template>


<script type="text/ecmascript-6">
    import '../css/turnplate.less';
    import error from '../../common/vue/error.vue';
    import confirm from './confirm.vue';
    import common from "../../common/js/common";
    import config from '../../../config/api.config';

    var timer;
    export default {
        data() {
            return {
                panelRotateClass: '',
                panelStyle: {},
                outerPanelClass: '',
                panelImg: null,
                errorConfig: {
                    show: false,
                    status: 1
                },
                panelInfo: null,
                interactionInfo: null,
                winnerRecord: null,
                playData: null,
                timesRemain: 0,
                timesUsed: 0,
                duringPlay: false,
                catchAward: 0,
                activityStatus: 0,//0 正常 1 未开始 2已结束 3 已下线
                activityStatusStr: '',
                //浮层相关
                confirmFlag: false,
                confirmImg: '',
                isAndroid: false,
                isiOS: false
            }
        },
        methods: {
            startRotate() {
                this.panelRotateClass = 'avatar';//内盘转动
                this.outerPanelClass = '';//外盘不动
                this.panelStyle = {       //内盘角度归位
                    backgroundImage: `url(${this.panelImg})`
                };
                this.duringPlay = true;
            },
            stopRotate(deg, cb) {
                let doAnimation = function () {
                    //内盘定位
                    this.panelStyle = {
                        backgroundImage: `url(${this.panelImg})`,
                        transform: 'rotate(' + deg + 'deg)',
                        WebkitTransform: 'rotate(' + deg + 'deg)'
                    };
                    this.outerPanelClass = 'avatarend';//外盘动
                    this.panelRotateClass = '';//内盘不动
                    if (cb) {
                        setTimeout(function () {
                            cb();
                            this.duringPlay = false;
                        }.bind(this), 3200)
                    }
                    else {
                        this.duringPlay = false;
                    }
                }.bind(this);
                let ua = window.navigator.userAgent.toLowerCase(),
                    iPhone = /iphone/i.test(ua),
                    android = /android/i.test(ua);
                if (iPhone) {
                    doAnimation();
                } else {
                    requestAnimFrame(doAnimation);
                }
            },
            getShareConfig() {
                let self = this;
                common.post(config.getShare, {
                    activityId: app.id, //抽奖id
                    activityType: 1
                }).then(data => {
                        let resData = data.data;
                        if (resData.status && resData.status.code === 0 && resData.result) {
                            let result = resData.result;
                            if (result.data) {
                                //分享配置
                                let title, pyq, content, img;
                                title = result.data.title;
                                pyq = result.data.title;
                                content = result.data.description;
                                img = result.data.imgHead;
                                if (!(/^https?/.test(img))) {
                                    img = window.location.protocol + img;
                                }
                                let share = window.pathTracker.share({
                                    config: {
                                        title: title,
                                        pyq: pyq,
                                        content: content,
                                        url: common.format2Code(window.location.href),
                                        img: img
                                    },
                                    option: {
                                        shareChannel: ["chats", "moments", "qq", 'qzone'],
                                        showTips: true,
                                        prependHtml: ''
                                    }
                                });
                            }

                        } else if (resData.status && resData.status.code === 2) {
                            common.vdianLogin();
                        }
                    },
                    () => {
                        self.errorConfig = {show: true, status: 1};
                    }
                );
            },
            getTurnplateInfo() {
                let self = this;
                common.post(config.getTurnplateInfo, {
                    id: app.id,//抽奖id
                    code: app.code
                }).then(data => {
                        let resData = data.data;
                        if (resData.status && resData.status.code === 0 && resData.result) {
                            let result = resData.result;
                            if (result.data) {
                                result.data.features = JSON.parse(result.data.features);
                                self.panelInfo = result;
                                self.confirmImg = result.data.features.preCondition && result.data.features.preCondition.mpQrCodePic || '';
                                document.title = self.panelInfo.data.name || '参与活动赢大奖';
                            }
                            //活动还没开始，下架也展示
                            if (resData.result.success === false) {
                                let errorCode = resData.result.errorCode;
                                if (errorCode === 31101) {
                                    self.activityStatus = 1;
                                } else if (errorCode === 31102) {
                                    self.activityStatus = 2;
                                } else if (errorCode === 31103) {
                                    self.activityStatus = 3;
                                } else {
                                    self.activityStatus = 999;//其他错误
                                }
                                self.activityStatusStr = resData.result.errorMsg;
                                new Kub.Toast({
                                    top: 300,
                                    message: resData.result.errorMsg,
                                    delay: 1500
                                });

                            }
                        } else if (resData.status && resData.status.code === 2) {
                            common.vdianLogin();
                        } else {
                            self.errorConfig = {show: true, status: 1};
                        }
                    },
                    () => {
                        self.errorConfig = {show: true, status: 1};
                    }
                );
            },
            getShopId(){
                let self = this;
                common.thorPost(config.getShopId, {
                    bizType: 404
                }).then(data => {
                        let resData = data.data;
                        if (resData.status && resData.status.code === 0 && resData.result) {
                            let result = resData.result;
                            eventBus.$emit('shopId',result.shopId || -1);//积分没了 shopId 为 null
                            //let shopId = result.shopId;
                        } else if (resData.status && resData.status.code === 2) {
                            common.vdianLogin();
                        } else {
                            self.errorConfig = {show: true, status: 1};
                        }
                    },
                    () => {
                        self.errorConfig = {show: true, status: 1};
                    }
                );
            },
            getInteractionInfo() {
                let self = this;
                common.vap({
                    url: config.getInteractionInfo,
                    dataIn: {
                        id: app.id,//抽奖id
                        code: app.code
                    },
                    ok: function (result) {
                        self.interactionInfo = result;
                    },
                    error: function () {
                        self.errorConfig = {show: true, status: 1};
                    }
                });
            },
            getWinnerRecord() {
                let self = this;
                common.vap({
                    url: config.getWinerRecord,
                    dataIn: {
                        activityId: app.id,//转盘id
                        code: app.code,
                        activityType: 1
                    },
                    ok: function (result) {
                        self.winnerRecord = result;
                    },
                    error: function () {
                        self.errorConfig = {show: true, status: 1};
                    }
                });
            },
            //获取剩余抽奖次数
            getRemainTimes() {
                let self = this;
                common.vap({
                    url: config.getRemainPlayTimes,
                    dataIn: {
                        id: app.id
                    },
                    ok: function (result) {
                        self.timesRemain = result.data;
                    },
                    error: function () {
                        self.errorConfig = {show: true, status: 1};
                    }
                });
            },
            vapPlay() {
                let self = this;
                common.post(config.play, {
                    id: app.id,//抽奖id
                    code: app.code
                }).then(data => {
                        let resData = data.data;
                        if (resData.status && resData.status.code === 0 && resData.result) {
                            if (resData.result.success === true) {
                                //正常逻辑
                                self.playData = resData.result;

                                if (self.playData && self.playData.data && self.playData.data.id && self.playData.data.awardType === 4){//中奖了 中了积分红包
                                    self.getShopId();
                                }
                            } else {
                                clearInterval(timer);
                                self.stopRotate(0);
                                new Kub.Toast({
                                    top: '40%',
                                    message: resData.result.errorMsg,
                                    delay: 2500
                                });
                                //如果次数用完，刷新页面
                                if (resData.result.errorCode === 31104) {
                                    setTimeout(function () {
                                        if (self.isAndroid) {
                                            window.location.href = common.updateUrl(window.location.href);
                                        } else {
                                            location.reload(true);
                                        }
                                    }, 1500);
                                }
                                //如果未关注公众号
                                if (resData.result.errorCode === 31115) {
                                    self.confirmFlag = true;
                                }
                            }

                        } else if (resData.status && resData.status.code === 2) {
                            //登录
                            common.vdianLogin();
                        } else {
                            //出错
                            clearInterval(timer);
                            self.stopRotate(0);
                            self.errorConfig = {show: true, status: 1};
                        }
                    },
                    () => {
                        //断网
                        clearInterval(timer);
                        self.stopRotate(0);
                        self.errorConfig = {show: true, status: 1};
                    }
                );
            },
            play() {
                if (this.activityStatus === 0 && this.chanceLeft > 0 && !this.duringPlay) {
                    let rotateTime = 2000, self = this;
                    this.playData = null;
                    this.startRotate();
                    this.vapPlay();
                    setTimeout(function () {
                        if (self.playData) {
                            self.handlePlayResult();
                        } else {//Todo 可以简化VAP 2S 超时
                            timer = setInterval(function () {
                                if (self.playData) {
                                    clearInterval(timer);
                                    self.handlePlayResult();
                                }
                            }, 1000);
                        }
                    }, rotateTime);
                }
            },
            handlePlayResult() {
                let self = this, stopDeg;
                stopDeg = this.computedDeg(this.playData.data.features);
                if (this.playData.data && this.playData.data.id) {//中奖
                    this.stopRotate(stopDeg, function () {
                        let data = self.playData.data;
                        eventBus.$emit('show', data);
                        self.timesUsed++;
                        self.catchAward++;
                    });
                } else {
                    //没中奖
                    this.stopRotate(stopDeg, function () {
                        self.timesUsed++;
                    });
                }
            },
            computedDeg(features) {
                let deg;
                try {
                    let featuresObj = JSON.parse(features),
                        winerInfoObj = featuresObj.winerInfo;
                    let {index, partNum} = winerInfoObj;
                    deg = (partNum + 1 - index) * 360 / partNum;
                    deg = ~~deg;
                } catch (e) {
                    deg = 0;
                }
                return deg;
            },
            goAwardsPage(e) {
                // location.href = `./com.html?id=${app.id}&code=${app.code}#/awards`;
                let originUrl = `./com.html?id=${app.id}&code=${app.code}#/awards`;
                let newUrl = spider.transferActionBy(originUrl, e.currentTarget);
                location.href = newUrl;
            },
            closeConfirm() {
                this.confirmFlag = false;
            }
        },
        computed: {
            pointerClass() {
                if (this.activityStatus === 0) {
                    if (this.chanceLeft > 0) {
                        return 'valid';
                    } else {
                        return 'invalid';
                    }
                } else {
                    return 'invalid';
                }

            },
            chanceLeft() {
                let value = this.timesRemain - this.timesUsed;
                if (value < 0) {
                    value = 0;
                }
                return value;
            },
            // chanceLeft(){
            //     let value;
            //     if (this.panelInfo && this.interactionInfo) {
            //         value = this.panelInfo.data.participationLimit - this.interactionInfo.totalCount - this.timesUsed;
            //         if (value < 0) {
            //             value = 0;
            //         }
            //     } else {
            //         value = 0;
            //     }
            //     return value;
            // },
            awardCnt() {
                if (this.winnerRecord) {
                    let awardsNotTaken = 0;
                    this.winnerRecord.data.forEach(item => {
                        /*if (item.status === 0) {
                         awardsNotTaken++;
                         }*/
                        awardsNotTaken++;
                        //奖品项就是所有中奖纪录
                    });
                    return awardsNotTaken + this.catchAward;
                } else {
                    return this.catchAward;
                }
            },
            couldRender() {
                return !this.errorConfig.show && this.interactionInfo && this.panelInfo && this.winnerRecord;
            },
            bgImg() {
                return this.panelInfo.data.features.lotteryBackGround || "//si.geilicdn.com/hz_img_014a0000015cce1e29d70a026860_750_1334_unadjust.png";
            }
        },
        components: {
            'vm-error': error,
            'vm-confirm': confirm
        },
        watch: {
            panelInfo(val) {
                if (val) {
                    let img = val.data.features.backgroudPic;
                    this.panelImg = img;
                    this.panelStyle = {
                        backgroundImage: `url(${img})`
                    };
                    /*app.needName = val.data.features.needName;
                    app.needTel = val.data.features.needPhone;
                    app.needWeChart = val.data.features.needWechat;
                    app.needAddress = val.data.features.needAddress;*/
                }
            }
        },
        created() {
            this.getTurnplateInfo();
            this.getRemainTimes();
            this.getInteractionInfo();
            this.getWinnerRecord();
            this.getShareConfig();
            let u = navigator.userAgent;
            this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
            this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        },
        mounted() {
            let self = this;
            if (app.code === undefined || app.id === undefined) {
                self.errorConfig = {show: true, status: 2};
            }
            window.addEventListener('touchmove', function (e) {
                if (self.duringPlay) {
                    e.preventDefault();
                }
            })
        },
        beforeDestroy() {
            eventBus.$emit('hide');
        }
    };

</script>



/** WEBPACK FOOTER **
 ** turnplate.vue?34fe1254
 **/